__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "my-basic-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@idui/react-popover", "3.1.0", () => (Promise.all([__webpack_require__.e(892), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(45892))))));
			register("mobx-react", "7.6.0", () => (Promise.all([__webpack_require__.e(233), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(745)]).then(() => (() => (__webpack_require__(96233))))));
			register("mobx", "6.16.1", () => (__webpack_require__.e(812).then(() => (() => (__webpack_require__(64812))))));
			register("moment", "2.31.0", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))));
			register("muuri-react", "3.1.7", () => (Promise.all([__webpack_require__.e(447), __webpack_require__.e(318), __webpack_require__.e(868)]).then(() => (() => (__webpack_require__(37447))))));
			register("muuri", "0.9.5", () => (__webpack_require__.e(947).then(() => (() => (__webpack_require__(45947))))));
			register("path-to-regexp", "1.9.0", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(44340))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(9370))))));
			register("react-bootstrap", "0.32.4", () => (Promise.all([__webpack_require__.e(296), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(48296))))));
			register("react-datepicker", "4.25.0", () => (Promise.all([__webpack_require__.e(899), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(31899))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-error-boundary", "3.1.4", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(177)]).then(() => (() => (__webpack_require__(59177))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(229), __webpack_require__.e(318), __webpack_require__.e(797), __webpack_require__.e(582)]).then(() => (() => (__webpack_require__(62582))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(229), __webpack_require__.e(688), __webpack_require__.e(318), __webpack_require__.e(389)]).then(() => (() => (__webpack_require__(91688))))));
			register("react-select", "5.10.2", () => (Promise.all([__webpack_require__.e(765), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(97765))))));
			register("react-table", "7.8.0", () => (Promise.all([__webpack_require__.e(94), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(71094))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("universal-cookie", "8.1.2", () => (__webpack_require__.e(750).then(() => (() => (__webpack_require__(34750))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(46453))))));
			initExternal(89503);
			initExternal(46006);
			initExternal(35833);
			initExternal(44905);
			initExternal(30628);
			initExternal(45744);
			initExternal(74944);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};